// src/tokens/spacing.ts
var componentSpacing01 = 1;
var componentSpacing02 = 2;
var componentSpacing03 = 3;
var componentSpacing04 = 4;
var componentSpacing05 = 5;
var componentSpacing06 = 6;
var componentSpacing07 = 7;
var componentSpacing08 = 8;
var componentSpacing09 = 9;
var layoutSpacing01 = 2;
var layoutSpacing02 = 3;
var layoutSpacing03 = 6;
var layoutSpacing04 = 8;
var layoutSpacing05 = 10;
export { componentSpacing01, componentSpacing02, componentSpacing03, componentSpacing04, componentSpacing05, componentSpacing06, componentSpacing07, componentSpacing08, componentSpacing09, layoutSpacing01, layoutSpacing02, layoutSpacing03, layoutSpacing04, layoutSpacing05 };